import React from 'react';
import { InputAdornment } from '@material-ui/core';
import { connect, FieldArray } from 'formik';
import Field from 'core/components/form/form.v2';
import flowRight from 'lodash-es/flowRight';
import AddButton from 'core/components/add-button';
import RemoveButton from 'core/components/remove-button';
import { FieldElementPropTypes } from '../propTypes';
import { useDisabledState } from 'common/disabled-context/context';

function ArrayField({ field: { id, name, value, label }, fieldProps }) {
  const field = id || name;
  const { disabled } = useDisabledState();
  const addAdornment = (pushValue) => (
    <InputAdornment position="end">
      <AddButton
        disabled={disabled}
        type="full"
        onClick={() => {
          pushValue(undefined);
        }}
      />
    </InputAdornment>
  );
  const removeAdornment = (removeValue, index) => (
    <InputAdornment position="end">
      <RemoveButton
        disabled={disabled}
        onClick={() => {
          removeValue(index);
        }}
      />
    </InputAdornment>
  );
  const canAdd = value?.length ? value.length < fieldProps.max : true;
  const lastIndex = value?.length ? value.length - 1 : 0;

  return (
    <FieldArray
      name={name}
      render={(arrayHelpers) => {
        return (
          <>
            {value?.length > 1
              ? value.map((val, index) => {
                  return (
                    <Field
                      id={`${field}.${index}`}
                      key={`${field}.${index}`}
                      name={`${field}.${index}`}
                      fast={false}
                      label={val ? `#${index + 1} ${label}` : `Add a ${label}`}
                      InputProps={{
                        endAdornment:
                          index !== lastIndex
                            ? removeAdornment(arrayHelpers.remove, index)
                            : canAdd
                              ? addAdornment(arrayHelpers.push)
                              : val
                                ? removeAdornment(arrayHelpers.remove, index)
                                : null
                      }}
                      {...fieldProps}
                    />
                  );
                })
              : null}
            {value?.length <= 1 && canAdd && (
              <Field
                id={`${field}.${lastIndex}`}
                name={`${field}.${lastIndex}`}
                fast={false}
                label={`Add a ${label}`}
                InputProps={{
                  endAdornment: addAdornment(arrayHelpers.push)
                }}
                {...fieldProps}
              />
            )}
          </>
        );
      }}
    />
  );
}
ArrayField.propTypes = FieldElementPropTypes;
export default flowRight(connect)(ArrayField);
